import { render, staticRenderFns } from "./TotalUnits.vue?vue&type=template&id=73710f85&"
import script from "./TotalUnits.vue?vue&type=script&lang=js&"
export * from "./TotalUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports